import { Button } from 'mypages-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from './PageTemplate';
import styles from './ChangePassword.module.scss';

export type InvalidTokenProps = {
  requestSmsToken: () => void;
  isLoading: boolean;
  error: string;
};

const InvalidToken = ({ requestSmsToken, isLoading, error }: InvalidTokenProps) => {
  const { t } = useTranslation();
  return (
    <PageTemplate>
      <h1 className={styles.title}>{t('MPL_FORGOT_PW_CODE_EXPIRED_TITLE')}</h1>
      <p className={styles.text}>{t('MPL_CHANGE_PW_VERIFICATION_CODE_EXPIRED')}</p>
      {error && <p className={styles.error}>{error}</p>}
      <Button
        text={t('MPL_RESEND_CODE')}
        className={styles.confirmButton}
        white
        disabled={isLoading}
        isLoading={isLoading}
        onClick={requestSmsToken}
        dataTestId="submit-resend-code"
      />
    </PageTemplate>
  );
};

export default InvalidToken;
